export { default } from "../src/page-saskatchewan";
